import { useNavigate, useParams } from "react-router-dom";
import Tabs from "../../ui/Tabs/Tabs";
import toSentenceCase from "../../util/toSentenceCase";
import Page from "../Page";
import AdminTeams from "./AdminTeams/AdminTeams";
import NotFound from "../NotFound/NotFound";
import urls from "../../routes";
import AdminArticles from "./AdminArticles/AdminArticles";
import styles from "./Admin.module.scss";

const tabs = [
  { label: "Teams", id: "teams", content: <AdminTeams /> },
  { label: "Articles", id: "articles", content: <AdminArticles /> },
];

function Admin() {
  const navigate = useNavigate();
  const { tabValue } = useParams();

  if (!tabValue || !tabs.map((tab) => tab.id).includes(tabValue)) {
    return <NotFound />;
  }

  return (
    <Page
      documentTitle={`Admin - ${toSentenceCase(tabValue)}`}
      title="Admin"
      fullHeight
    >
      <Tabs
        className={styles.container}
        defaultValue="teams"
        value={tabValue}
        onValueChange={(value) => navigate(`${urls.admin.root}/${value}`)}
        tabs={tabs}
      />
    </Page>
  );
}

export default Admin;
